<template>
  <div class="crud-detail-deposit-product-fieldset">
    <b-row :class="[{'block-product-add':crud.form.detail_register.editing}]">
      <b-col lg="4">
        <FindObject :key="'products-compound-' + crud.form.detail_register.forceRenderSelectProduct"
                    render="search"
                    type="productsCompound" 
                    @select-object="loadProductsCompound($event)" 
                    :valueID="crud.form.detail_register.productCompound_id"
                    :where="conditionProductsCompoundActive"/> 
      </b-col>
      <b-col lg="8">
        <b-row v-if="crud.form.detail_register.unit_measurement">
          
          <b-col lg="3">
            <b-form-group label="Cantidad">
              <b-input-group size="sm" :append="crud.form.detail_register.unit_measurement.reference">
                <app-text-input v-model="crud.form.detail_register.quantity"
                                type="number"
                                min="0"
                                step="1.0000"
                                class="form-control" />
              </b-input-group>
            </b-form-group>            
          </b-col>                   
          <b-col lg="4">          
            <FindObject :key="'deposits-locations-origin-' + crud.form.detail_register.forceRenderSelectProduct"
                        tag="Ubicación Origen"
                        render="search"
                        type="deposits-location" 
                        display="full_reference" 
                        @select-object="loadLocations($event)" 
                        :valueID="crud.form.detail_register.location_id"
                        auto-select-single
                        :where="conditionLocationActive"                         
                        :orWhere="conditionLocationActiveOR" 
                        :showAllRegister="this.crud.form.detail_register.productCompound.depositLocationDetail.length"/>
          </b-col>
          <b-col lg="4">          
            <FindObject :key="'deposits-locations-destination-' + crud.form.detail_register.forceRenderSelectProduct"
                        tag="Ubicación Destino"
                        render="search"
                        type="deposits-location" 
                        display="full_reference" 
                        @select-object="loadLocationsDestination($event)" 
                        :valueID="crud.form.detail_register.location_destination_id"
                        auto-select-single
                        :where="conditionLocationActive" 
                        v-if="operation.reference == 'transferencia'"
                        :showAllRegister="false"/>
          </b-col>
          <b-col lg="1" class="crud-new-orders-button-add">              
            <b-button @click="addItem()" 
                      v-b-tooltip.hover 
                      :variant="crud.form.detail_register.button.variant"
                      :title="crud.form.detail_register.button.title"
                      size="sm">
              <AppIcon :name="crud.form.detail_register.button.icon" />
            </b-button>                                                  
          </b-col>

        </b-row>
      </b-col>
      <b-col lg="12" v-if="crud.form.detail_register.editing" class="block-product-add-div">
        <AppIcon name="circle-fill" fill font-scale="2" />
      </b-col>      
    </b-row>
    <b-row class="mt-2">
      <b-col md="12">                  
        <b-table :key="'table_product_compound_' + forceUpdate"
          class="mb-0 app-table app-table--compact crud-order-table-detail"
          responsive="sm"
          :stacked="isMobileViewport ? 'md' : false"
          :hover="true"
          :small="true"
          :fixed="false"
          :items="crud.form.detail"
          :fields="tableDetailNewOrder">
          
          <template v-slot:cell(code)="data">              
            {{data.item.productCompound.code}}
          </template>  

          <template v-slot:cell(product)="data">  
            <div :class="isMobileViewport ? 'text-wrap' : 'text-truncate'" v-b-tooltip.hover :title="data.item.productCompound ? data.item.productCompound.name : ''">
              {{data.item.productCompound.name}}
            </div>              
          </template>   

          <template v-slot:cell(quantity)="data">                            
            <b-input-group v-if="allowInlineDetailEdit" size="sm" class="detail-inline-input">
              <b-form-input v-model="data.item.quantity"
                            type="number"
                            min="0.0001"
                            step="0.0001"
                            @change="updateInlineQuantity(data.item)" />
              <b-input-group-append is-text v-if="data.item.unit_measurement">
                {{data.item.unit_measurement.reference}}
              </b-input-group-append>
            </b-input-group>
            <template v-else>
              {{ parseFloat(data.item.quantity).toFixed(4) }}
              <span v-if="data.item.unit_measurement">{{data.item.unit_measurement.reference}}</span>
            </template>
          </template>   

          <template v-slot:cell(deposit)="data">                          
            <b-form-select v-if="allowInlineDetailEdit"
                           v-model="data.item.location_id"
                           :options="locationOptions"
                           size="sm"
                           @change="updateInlineLocation(data.item, $event)" />
            <DepositLocationLabel v-else :location="data.item.location" />
          </template>  

          <template v-slot:cell(deposit_destination)="data">                          
            <DepositLocationLabel :location="data.item.location_destination" />
          </template>

          <template v-slot:cell(f_action)="data">  
            <b-dropdown right 
                        no-caret
                        size="sm" 
                        variant="link"
                        boundary="window"
                        :toggle-class="isMobileViewport ? 'crud-deposit-detail-action-toggle-labeled' : 'app-table-action-toggle'"
                        :disabled="crud.form.detail_register.button.editing">                                    
              <template #button-content>
                <AppIcon name="more_vert" :label="isMobileViewport ? 'Opciones' : 'Acciones'" :class="{ 'mr-1': isMobileViewport }" />
                <span v-if="isMobileViewport">Opciones</span>
              </template>
              <b-dropdown-item @click="editItem(data.item, data.index)">
                <AppIcon name="edit" /> Editar
              </b-dropdown-item>
              <b-dropdown-item @click="deleteItem(data.index)">
                <AppIcon name="delete" class="text-danger" /> Eliminar
              </b-dropdown-item>     
            </b-dropdown>                                
          </template>                    
        </b-table>                  
      </b-col>
    </b-row> 

  </div>       
</template>

<script>
  import FindObject from '@/components/inc/find/findObject'    
  import serviceAPI from './services'

  export default {
    props: {
      operation: {
        type: [Object, Array],
        default: () => [],        
      },      
      detailEdit: {
        type: [Array, Object],
        default: null,
      },
      forceUpdate: {
        type: Number,
        default: 0,
      },
      allowInlineDetailEdit: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      FindObject,
    },
    data: () => {
      return {  
        tableDetailNewOrder : [],           
        crud: {
          form: {
            detail_register: {
              quantity: 0,
              quantityOld: 0,      
              productCompound_id: 0,
              productCompound: null,     
              forceRenderSelectProduct: 0,
              unit_measurement: null,
              unit_measurement_id: 0,     
              location: null,
              location_id: 0,
              location_destination: null,
              location_destination_id: 0,             
              purchase_orders_id: 0,
              purchase_orders_detail_id: 0,
              button: {
                icon: 'fa fa-plus',
                title: 'Agreagr Item',
                variant: 'success',
                editing: false
              },
              editing: false,                 
            },  
            detail: [],           
          },               
        },      
        isMobileViewport: false,
        locations: [],
      }
    },
    computed: {
      // CONDITIONS SELECT   
      conditionLocationActive() {        
        var conditional = []
        conditional.push({field: 'active', condition: true})
        return conditional        
      },
      conditionLocationActiveOR() {        
        var conditional = []
        
        if(this.operation.reference == 'sub-manual' || this.operation.reference == 'transferencia') {                        
          if(this.crud.form.detail_register.productCompound) {
            if(this.crud.form.detail_register.productCompound.depositLocationDetail) {
              this.crud.form.detail_register.productCompound.depositLocationDetail.forEach(element => {
                if(element.quantity>0) {
                  conditional.push({field: 'id', condition: element.location_id})
                }              
              });
            }
          }
        }
        
        if(!conditional.length) {
          if(this.operation.type && this.operation.type.type_balance == '+')
            conditional = [];
          else 
            conditional.push({field: 'id', condition: -1})                      
        }        
        
        return conditional
      },   
      conditionProductsCompoundActive() {
        return [{field: 'active', condition: true}];
      },
      locationOptions() {
        return this.locations.map((location) => ({
          value: location.id,
          text: this.getLocationLabel(location),
        }))
      },
    },    
    mounted() {
      this.mobileMql = window.matchMedia('(max-width: 767.98px)')
      this.isMobileViewport = this.mobileMql.matches
      this.mobileMql.addEventListener('change', this.updateMobileViewport)

      this.configFieldsTable()
      this.loadItems()
      if(this.allowInlineDetailEdit) {
        this.loadAvailableLocations()
      }
    },
    beforeDestroy() {
      if(this.mobileMql) {
        this.mobileMql.removeEventListener('change', this.updateMobileViewport)
      }
    },
    watch: {
      isMobileViewport() {
        this.configFieldsTable()
      },
    },
    methods: {
      updateMobileViewport(e) {
        this.isMobileViewport = e.matches
      },
      alignClass(desktopClass) {
        return this.isMobileViewport ? 'text-left' : desktopClass
      },
      configFieldsTable() {
        this.tableDetailNewOrder = []
        this.tableDetailNewOrder.push({key: 'code', label: 'Código', class:"align-middle " + this.alignClass('text-left')})              
        this.tableDetailNewOrder.push({key: 'product', label: 'Producto', class:"align-middle " + this.alignClass('text-left')})              
        this.tableDetailNewOrder.push({key: 'quantity', label: 'Cantidad', class:"align-middle " + this.alignClass('text-center')})                
        this.tableDetailNewOrder.push({key: 'deposit', label: 'Ubicación (Origen)', class:"align-middle " + this.alignClass('text-left')})                

        if(this.operation.reference == 'transferencia') {
          this.tableDetailNewOrder.push({key: 'deposit_destination', label: 'Ubicación (Destino)', class:"align-middle " + this.alignClass('text-left')})  
        }

        this.tableDetailNewOrder.push({key: 'f_action', label: this.isMobileViewport ? 'Acción' : '', class:"align-middle " + this.alignClass('text-right')})
      },
      loadItems() {              
        if(this.detailEdit) {
          this.detailEdit.forEach(element => {         
            var arrItem = { 
              productCompound: element.productCompound, 
              quantity: parseFloat(element.quantity), 
              quantityOld: parseFloat(element.quantity),
              unit_measurement: element.unit_measurement,
              location: element.location,
              location_id: element.location ? element.location.id : 0,
              location_destination: element.location_destination,              
              purchase_orders_id: element.purchase_orders_id || 0,
              purchase_orders_detail_id: element.purchase_orders_detail_id || 0,
            }

            this.crud.form.detail.push(arrItem)                  
          });
          
          this.$emit('load-detail', this.crud.form.detail)
        }
      },      
      loadAvailableLocations() {
        return serviceAPI.obtenerUbicacionesDeposito({
          filter: '',
          where: [{field: 'active', condition: true}],
          orWhere: [],
        })
        .then((response) => {
          this.locations = Array.isArray(response.data) ? response.data : []
        })
      },
      getLocationLabel(location) {
        if(!location) return ''
        if(!location.zone || !location.zone.deposit) {
          return location.full_reference || location.reference || location.name || ''
        }
        var depositName = location.zone.deposit.name || location.zone.deposit.reference || ''
        if(location.full_reference && location.full_reference == depositName) {
          return depositName
        }
        var parts = []
        parts.push(depositName)
        parts.push(location.zone.reference || location.zone.name)
        parts.push(location.reference || location.name || 'Ubicación sin nombre')
        return parts.filter(Boolean).join(' / ')
      },
      updateInlineQuantity(item) {
        var quantity = parseFloat(item.quantity)
        item.quantity = quantity > 0 ? quantity : 1
        this.$emit('load-detail', this.crud.form.detail)
      },
      updateInlineLocation(item, locationID) {
        var location = this.locations.find((element) => element.id == locationID) || null
        item.location = location ? Object.assign({}, location) : null
        if(item.location) delete item.location.contains
        item.location_id = location ? location.id : 0
        this.$emit('load-detail', this.crud.form.detail)
      },
      loadProductsCompound (object) {        
        if(object){
          this.crud.form.detail_register.productCompound = object
          this.crud.form.detail_register.productCompound_id = object.id     

          this.crud.form.detail_register.unit_measurement = object.unit_measurement
          this.crud.form.detail_register.unit_measurement_id = object.unit_measurement.id               
                    
          this.crud.form.detail_register.forceRenderSelectProduct = object.id                  
        } else {                    
          this.crud.form.detail_register.productCompound = null
          this.crud.form.detail_register.productCompound_id = 0                            
          
          this.crud.form.detail_register.unit_measurement = null
          this.crud.form.detail_register.unit_measurement_id = 0     
          
          this.crud.form.detail_register.quantity = 0          
          this.crud.form.detail_register.unit_measurement = null
          this.crud.form.detail_register.unit_measurement_id = 0

          this.crud.form.detail_register.location = null
          this.crud.form.detail_register.location_id = 0
          this.crud.form.detail_register.location_destination = null
          this.crud.form.detail_register.location_destination_id = 0     
          this.crud.form.detail_register.purchase_orders_id = 0
          this.crud.form.detail_register.purchase_orders_detail_id = 0
          
          this.crud.form.detail_register.button.title = "Agregar Item"
          this.crud.form.detail_register.button.icon = "fa fa-plus"
          this.crud.form.detail_register.button.variant = "success"                
        }
      },    
      loadLocations (object) {
        if(object){
          this.crud.form.detail_register.location = object
          this.crud.form.detail_register.location_id = object.id
        } else {
          this.crud.form.detail_register.location = null
          this.crud.form.detail_register.location_id = 0
        }
      },
      loadLocationsDestination (object) {
        if(object){
          this.crud.form.detail_register.location_destination = object
          this.crud.form.detail_register.location_destination_id = object.id
        } else {
          this.crud.form.detail_register.location_destination = null
          this.crud.form.detail_register.location_destination_id = 0
        }
      },

      // ABM MAIN DETAILS
      addItem() {             
        // cantidad
        if (this.crud.form.detail_register.quantity.toString() == '' || parseFloat(this.crud.form.detail_register.quantity)<=0) {
          this.$awn.alert('La cantidad debe ser mayor a cero')          
          return false
        }
                 
        // producto compuesto
        if(!this.crud.form.detail_register.productCompound) {
          this.$awn.alert('No se cargó el producto')          
          return false
        }      
        
        // deposito/zona/ubicacion Origen
        if (!this.crud.form.detail_register.location) {
          this.$awn.alert('Falta seleccionar la ubicación')          
          return false
        }      
        
        // deposito/zona/ubicacion Destino
        if(this.operation.reference == 'transferencia') {
          if (!this.crud.form.detail_register.location_destination) {
            this.$awn.alert('Falta seleccionar la ubicación destino')          
            return false
          }              
        }

        // ubicación en transferencia
        if(!this.validDepositLocation()) {
          this.$awn.alert('La ubicación en depósito de salida no puede ser la misma que la ubicación de entrada') 
          return false          
        }

        // duplicado
        if(!this.validDuplicatedItem()) {
          this.$awn.alert('Item Duplicado') 
          return false          
        }

        var arrItem = { 
          productCompound: this.crud.form.detail_register.productCompound,
          quantity: parseFloat(this.crud.form.detail_register.quantity),
          quantityOld: parseFloat(this.crud.form.detail_register.quantityOld),
          unit_measurement: this.crud.form.detail_register.unit_measurement,
          location: this.crud.form.detail_register.location,
          location_destination: this.crud.form.detail_register.location_destination,
          purchase_orders_id: this.crud.form.detail_register.purchase_orders_id || 0,
          purchase_orders_detail_id: this.crud.form.detail_register.purchase_orders_detail_id || 0,
        }

        this.crud.form.detail.push(arrItem)
        this.$emit('load-detail', this.crud.form.detail)
        
        this.crud.form.detail_register.forceRenderSelectProduct = 0
        this.loadProductsCompound(null)       
        
        this.crud.form.detail_register.button.editing = false
      },
      editItem (item, index) {    
        this.crud.form.detail_register.editing = true
        this.crud.form.detail_register.quantity = item.quantity
        this.crud.form.detail_register.quantityOld = item.quantityOld  
        this.crud.form.detail_register.location = item.location
        this.crud.form.detail_register.location_id = item.location.id
        this.crud.form.detail_register.purchase_orders_id = item.purchase_orders_id || 0
        this.crud.form.detail_register.purchase_orders_detail_id = item.purchase_orders_detail_id || 0
                
        if(item.location_destination) {
          this.crud.form.detail_register.location_destination = item.location_destination
          this.crud.form.detail_register.location_destination_id = item.location_destination.id        
        }
        
        this.crud.form.detail_register.productCompound_id = item.productCompound.id
        this.crud.form.detail_register.forceRenderSelectProduct = item.productCompound.id    

        this.crud.form.detail_register.editing = false
        
        this.crud.form.detail_register.button.title = "Editar Item"
        this.crud.form.detail_register.button.icon = "fa fa-save"
        this.crud.form.detail_register.button.variant = "warning"
        this.crud.form.detail_register.button.editing = true

        this.crud.form.detail.splice(index, 1)
        this.$emit('load-detail', this.crud.form.detail)
      },
      deleteItem (index) {
        this.crud.form.detail.splice(index, 1)
        this.$emit('load-detail', this.crud.form.detail)
      },
      
      // VALID DUPLICATED
      validDuplicatedItem() {
        var item = this.crud.form.detail_register.productCompound
        var location_id = this.crud.form.detail_register.location_id
        var status = true
        if(this.crud.form.detail) {
          this.crud.form.detail.forEach(element => {                                                
            if(element.productCompound.id == item.id && element.location.id == location_id) {
              status = false
            }                         
          });
        }
        return status
      },    
      
      // VALID DEPOSIT / UBICACION EN TRANSFERENCIA
      validDepositLocation() {
        var status = true
        var value = this.crud.form.detail_register

        if(this.operation.reference == 'transferencia') {
          if(parseFloat(value.location_id) == parseFloat(value.location_destination_id)) {
            status = false
          }
        }
        
        return status
      },   
        
    }
  }
</script>
<style>
  .crud-order-table-detail {
    overflow: auto;
    max-height: 350px;    
    min-height: 100px;    
  }
  .block-product-add {
    background: white;
    filter: brightness(0.4);
    border-radius: 15px;
    padding-top: 10px;
    pointer-events: none;
    opacity: 0.5;
  }
  .block-product-add-div {
    position: absolute;
    text-align: center;
    margin-top: 20px;    
  }  
  .crud-new-orders-button-add {
    margin-top: 29px;
  }
  .crud-detail-deposit-product-fieldset fieldset {
    margin-bottom: 0 !important;
  }
  .btn.crud-deposit-detail-action-toggle-labeled {
    display: inline-flex !important;
    align-items: center;
    justify-content: flex-start;
    width: auto !important;
    height: auto !important;
    min-height: 0;
    padding: 0 !important;
    border: none !important;
    background: transparent !important;
    box-shadow: none !important;
    color: var(--app-color-text-secondary) !important;
    font-size: 13px;
    line-height: 1.15;
  }
  .btn.crud-deposit-detail-action-toggle-labeled:hover,
  .btn.crud-deposit-detail-action-toggle-labeled:focus {
    color: var(--app-color-primary) !important;
    text-decoration: underline;
  }
  @media (max-width: 767.98px) {
    .crud-order-table-detail.app-table.b-table-stacked-md > tbody > tr > td:last-child::before {
      content: attr(data-label) !important;
    }
    .crud-order-table-detail.app-table.b-table-stacked-md > tbody > tr > td:last-child {
      align-items: flex-start;
      padding-top: 10px !important;
    }
  }
  .curd-detail-product-select-unit-measurement {
    font-size: 10px !important;
    padding-left: 3px !important;
    padding-right: 3px !important;
  }
  .curd-detail-product-select-unit-measurement button {
    font-size: 10px;
    padding-left: 3px;
    padding-right: 3px;
  }
</style>
